import { invoke } from '@shared/easyfy.decorators';
import { removeCss } from '@shared/easyfy.utils';
import { globalEvent } from '@shared/easyfy.core';
import Toggle from '@clientShared/toggle';

@invoke
export default class LoginFlyout {
  static Instance: LoginFlyout;

  onInit() {
    globalEvent({
      type: 'click',
      events: [
        {
          event: 'close-login',
          callback: this.closeLogin,
        },
      ],
    });
  }

  private closeLogin = (e: Event): void => {
    e.preventDefault();
    e.stopPropagation();

    const mainMenu = document.querySelector<HTMLElement>('[data-container="main-menu"][data-toggle-open]');
    if (mainMenu) {
      Toggle.Instance.closeModal(mainMenu);
      this.resetMenuState(mainMenu);
      return;
    }

    const loginFlyout = document.querySelector<HTMLElement>('[data-container="login-flyout"]');
    if (loginFlyout) {
      Toggle.Instance.closeModal(loginFlyout);
    }
  };

  private resetMenuState(mainMenu: HTMLElement): void {
    mainMenu.querySelectorAll<HTMLElement>('.mm-active, .mm-visited').forEach((el) => {
      removeCss(el, 'mm-active');
      removeCss(el, 'mm-visited');
    });
  }
}
